const PESEL_WEIGHTS = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];

/** PESEL: 11 cyfr i cyfra kontrolna (wagi 1-3-7-9). Ostateczną walidację robi BE. */
export const isValidPesel = (value: string) => {
  if (!/^\d{11}$/.test(value)) return false;

  const sum = PESEL_WEIGHTS.reduce(
    (acc, weight, index) => acc + weight * Number(value[index]),
    0,
  );

  return (10 - (sum % 10)) % 10 === Number(value[10]);
};
